var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mobile_AppHeader'),_c('main',[_vm._t("default")],2),_c('mobile_AppFooter'),_c('mobile_Tel'),_c('mobile_BackTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }